import React, { useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';

import { useExaminationsActions, useAlerts, FILE_ID, FILE_URL, FILE_URL_EXPIRES, BUCKET, MIMETYPE } from 'store/examinations';
import Download from 'assets/svg-icons/Download';

import { Container } from './styles';

const PdfButton = ({ fileData, url }) => {
  const { [FILE_ID]: id } = fileData || {};
  const { loadFile } = useExaminationsActions();
  const { action, loading, success, resetAlerts } = useAlerts(loadFile);
  const handleClick = useCallback(() => {
    if (id) {
      action(fileData);
    } else if (url) {
      window.open(url, '_blank');
    }
  }, [action, fileData, id, url]);

  useEffect(() => {
    if (success) {
      window.open(success, '_blank');
      resetAlerts();
    }
  }, [resetAlerts, success]);

  return (
    <Container type="button" onClick={handleClick} disabled={loading}>
      <Download />
    </Container>
  );
};

PdfButton.defaultProps = { fileData: null, url: null };
PdfButton.propTypes = {
  fileData: PropTypes.shape({
    [FILE_ID]: PropTypes.string,
    [FILE_URL]: PropTypes.string,
    [FILE_URL_EXPIRES]: PropTypes.string,
    [BUCKET]: PropTypes.string,
    [MIMETYPE]: PropTypes.string,
  }),
  url: PropTypes.string,
};

export default PdfButton;
